import { doc, getDoc, setDoc, serverTimestamp } from 'firebase/firestore';
import { db } from '../firebaseClient';

const MAX_ACTIVITY_ENTRIES = 6;

// Appends a real-time activity entry (course completed, level up, certificate
// earned, etc.) to learnerPoints/{userId}.activity, capped to the most recent entries.
export const logActivity = async (userId, { type, label, icon, color }) => {
  if (!userId) return;
  const ref = doc(db, 'learnerPoints', userId);
  const snap = await getDoc(ref);
  const existing = snap.exists() ? snap.data()?.activity || [] : [];

  const entry = {
    id: `${Date.now()}_${Math.random().toString(36).slice(2, 8)}`,
    type,
    label,
    icon,
    color: color || 'text-accent',
    at: new Date().toISOString(),
  };

  const updated = [entry, ...existing].slice(0, MAX_ACTIVITY_ENTRIES);

  await setDoc(
    ref,
    { userId, activity: updated, updatedAt: serverTimestamp() },
    { merge: true }
  );
};

export const getLearnerActivity = async (userId) => {
  if (!userId) return [];
  const ref = doc(db, 'learnerPoints', userId);
  const snap = await getDoc(ref);
  return snap.exists() ? snap.data()?.activity || [] : [];
};